// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/.0.28.7@css-loader/index.js??ref--1-oneOf-2-2!../../../../node_modules/.2.0.8@postcss-loader/lib/index.js??postcss!../../../../node_modules/.4.1.0@less-loader/dist/cjs.js??ref--1-oneOf-2-4!./HeadersTable.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../node_modules/.0.19.0@style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;



//////////////////
// WEBPACK FOOTER
// ./src/routes/project/components/HeadersTable.less
// module id = 1230
// module chunks = 0